import * as Yup from 'yup'

import { carCode, email, exactlyLengthVin, plateNumber, radioGroup, shortVin, vin } from 'utils/yup'

export const REGISTER_VEHICLE_WITH_VIN_SCHEMA = Yup.object().shape({
  Vin: vin,
})

export const REGISTER_VEHICLE_WITH_SHORT_VIN_SCHEMA = Yup.object().shape({
  ShortVin: shortVin,
})

export const DELETE_VEHICLE_SCHEMA = Yup.object().shape({
  radioGroup,
})

export const TRANSFER_VEHICLE_SCHEMA = Yup.object().shape({
  emailVehicleTransfer: email,
})

export const CHECK_PLATE_NUMBER_SCHEMA = Yup.object().shape({
  plateNumber: plateNumber.notRequired(),
  vin: exactlyLengthVin,
  radioGroup
})

export const CHECK_CARCODE_SCHEMA = Yup.object().shape({
  carCode: carCode.notRequired()
})
